import { updateCommunity } from "../../services/community/updateCommunity";
import { updateCommunityImage } from "../../services/community/updateCommunityImage";
import { CommunityUpdateDTO } from "../../interfaces";
import isEqual from "fast-deep-equal";
import {
  updateVipConfiguration,
  UpdateVipConfigurationDTO,
} from "services/community/updateVipConfiguration";

export async function updateCommunityUseCase(
  id: string,
  variables: CommunityUpdateDTO,
  initialVipConfiguration?: any,
) {
  await updateCommunity(id, variables);

  if (variables.image !== undefined && variables.image !== null) {
    await updateCommunityImage(id, variables.image);
  }

  if (
    variables.vipConfiguration &&
    initialVipConfiguration &&
    !isEqual(initialVipConfiguration, variables.vipConfiguration)
  ) {
    const vipConfiguration: UpdateVipConfigurationDTO = {
      ...variables.vipConfiguration,
      price: Number(variables.vipConfiguration.price),
      fee: Number(variables.vipConfiguration.fee),
      communityId: id,
    };
    await updateVipConfiguration(vipConfiguration);
  }
}
